// extracted by mini-css-extract-plugin
export default {"errorMessage":"Error_errorMessage__qlBHG"};